const replaceFullWidthChars = (str: string): string => {
  if (!str) {
    str = '';
  }

  const fullWidth = '\uff10\uff11\uff12\uff13\uff14\uff15\uff16\uff17\uff18\uff19';
  const halfWidth = '0123456789';

  let value = '';

  for (let char of str) {
    const index = fullWidth.indexOf(char);

    if (index > -1) {
      char = halfWidth[index];
    }

    value += char;
  }

  return value;
};

export const sanitizeCardExpiry = (expiry: string): string =>
  replaceFullWidthChars(expiry)
    .replace(/([^\d/])/g, '')
    .replace(/^\D*(\d{1,2})?\D*\/\D*(\d{1,2})?\D*$/, '$1/$2');

export const sanitizeCardNumber = (cardNumber: string): string => replaceFullWidthChars(cardNumber).replace(/\D/g, '');

export const sanitizeCardCVV = (cardCVV: string) => cardCVV.replace(/\D/g, '');
